module.exports = "<div class=\"container-fluid container-limited\">\n\n<h3 translate>ACCOUNT_JustActivatedTitle</h3>\n<p translate>ACCOUNT_JustActivatedText</p>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/account/other/justactivated.html
// module id = 122
// module chunks = 0